import { render, staticRenderFns } from "./VerifyEmailLender.vue?vue&type=template&id=0461f20f&scoped=true"
import script from "./VerifyEmailLender.vue?vue&type=script&lang=js"
export * from "./VerifyEmailLender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0461f20f",
  null
  
)

export default component.exports